import { User } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';
const StyledImage = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Avatar__StyledImage",
  componentId: "sc-nqcw6k-0"
})(["display:flex;justify-content:center;align-items:center;border-radius:50%;background-size:cover;background-image:url(", ");"], props => props.src);
/**
 * @public
 */
export function Avatar({
  altText = 'avatar',
  className = '',
  color = 'primary',
  colorScheme,
  initials,
  subtitle,
  src,
  size = 40,
  title
}) {
  return React.createElement(Flex, {
    className: className
  }, React.createElement(StyledImage, {
    role: 'img',
    src: src,
    alt: altText,
    size: size,
    minWidth: size,
    color: color,
    p: 2,
    colorScheme: colorScheme
  }, !src && initials && React.createElement(Text, {
    fontSize: 1
  }, initials.toUpperCase()), !src && !initials && React.createElement(User, null)), title && React.createElement(Flex, {
    flexDirection: 'column',
    justifyContent: 'center',
    ml: 3
  }, React.createElement(Heading.h5, {
    m: 0
  }, title), React.createElement(Text, {
    color: 'text.light',
    fontSize: 0
  }, subtitle)));
}
Avatar.displayName = 'Avatar';